<template>
  <div class="index">
    <Navbar />
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from 'components/BondedLoan/Navbar'
import router from '../../router'

export default {
  name: 'Loans',
  data () {
    return {
    }
  },
  created () {
    if (!this.$route.params.id && this.$route.name === 'Loans') {
      router.push('/loans/bonded-loan')
    }
  },
  components: { Navbar }
}
</script>



// WEBPACK FOOTER //
// Loans.vue?744ba4ea